<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs3-05",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 46,
      nextPage: '/questionnaire/section3/6',
      navigateType: 'CLICK_ANY_BTN',
      content: {
        componentsType: {
          pc: 'longBtn',
          mobile: 'longBtn'
        },
        mainTitle: 'How often do you drink milk or eat soy products?',
        btn: [
          [
            {
              text: 'Eat three meals a day',
            }
          ],[
            {
              text: 'Once a day',
            }
          ],[
            {
              text: 'Eat every two or three days',
              operation: 'flag3-1_Vegan_add suggestion 2 & flag3-1_Pescatarian_add suggestion 4 & flag3-1_Anything_add suggestion 8'
            }
          ],[
            {
              text: 'Rarely',
              operation: 'flag3-1_Vegan_add suggestion 2 & flag3-1_Pescatarian_add suggestion 4 & flag3-1_Anything_add suggestion 8'
            }
          ]
        ],
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
